import { getApplicantFieldValue } from '../../../../../RentalPortalApplicant'

export function toApplicantProfileEmailsParticipantValue(participant) {
  const identity = getApplicantFieldValue(participant)

  return identity
    ? {
        user: {
          avatar: identity.avatar_thumb_url,
          avatarColor: identity.avatar_color,
          fullname: identity.full_name,
          key: identity.id,
        },
      }
    : null
}
